import * as z from "zod";

export const LoginSchema = z.object({
  email: z.string().email({ message: "Email is required" }).toLowerCase(),
  password: z.string().min(1, {
    message: "Password is required",
  }),
  csrfToken: z.string().optional(),
  code: z.optional(z.string()),
});

export const RegisterSchema = z.object({
  email: z.string().email({ message: "Email is required" }).toLowerCase(),
  password: z.string().min(6, {
    message: "Minimum 6 characters required",
  }),
  name: z.string().min(1, { message: "Name is required" }),
  surname: z.string().min(1, { message: "Surname is required" }),
});

export const ResetPasswordSchema = z.object({
  email: z.string().email({ message: "Email is required" }).toLowerCase(),
});

export const NewPasswordSchema = z.object({
  password: z.string().min(6, {
    message: "Minimum 6 characters required",
  }),
});

export const NewTrialSchema = z.object({
  email: z.string().email().min(1, { message: "Email is required." }).toLowerCase(),
});

export const InviteNewUserSchema = z.object({
  email: z.string().email({ message: "Email is required" }).toLowerCase(),
});

export const TrialUserRegistrationSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
  surname: z.string().min(1, { message: "Surname is required" }),
  email: z.string().email({ message: "Email is required" }).toLowerCase(),
  mobile: z.string().optional(),
  password: z.string().min(6, {
    message: "Minimum 6 characters required",
  }),
  confirmPassword: z.string().min(6, {
    message: "Minimum 6 characters required",
  }),
});

export const TrialSubscriptionRegistrationSchema = z.object({
  id: z.string().optional(),
  name: z.string(),
  tradingAs: z.string(),
  telephone: z.string(),
  mobile: z.string(),
  email: z.string().email().toLowerCase(),
  fullAddress: z.string(),
  web: z.string().optional().nullable(),
  vatNo: z.string().optional().nullable(),
  regNo: z.string().optional().nullable(),
});

export const TrialSubscriptionBankingSchema = z.object({
  id: z.string().optional(),
  bankName: z.string(),
  bankAccountNo: z.string(),
  bankAccountType: z.string(),
  bankBranchCode: z.string(),
});

export const TrialCalendarRegistrationSchema = z.object({
  calendarDailyLimit: z.number().min(1, { message: "Daily limit is required" }),
  calendarBlockPublicHolidays: z.boolean(),
  calendarBlockWeekDays: z.array(z.string()),
});

export const InitialProfile_WorkshopSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
  telephone: z.string(),
  email: z.string().email().toLowerCase(),
  web: z.string().optional(),
});

export const InitialProfile_BankAndRegSchema = z.object({
  bank: z.string().optional(),
  bankAccount: z.string().optional(),
  bankBranch: z.string().optional(),
  registration: z.string().optional(),
  vat: z.string().optional(),
  registeredName: z.string().optional(),
});

export const InitialProfile_AddressSchema = z.object({
  address: z.string().optional(),
  building: z.string().optional(),
  suburb: z.string().optional(),
  city: z.string().optional(),
  province: z.string().optional(),
  postalCode: z.string().optional(),
});

export const FormSchema = z.object({
  name: z.string().min(4),
  description: z.string().optional(),
});
export type FormSchemaType = z.infer<typeof FormSchema>;

export const ContactSalesSchema = z.object({
  name: z.string(),
  email: z.string().email().toLowerCase(),
  phone: z.string(),
  message: z.string(),
});
